module.exports = __webpack_public_path__ + "img/0bd23bf.svg";